import React, {useState} from "react";
import TreatmentDetail from "../../components/treatment/TreatmentDetail";
import {Tabs} from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import ExpandablePanel from "../../components/ExpandablePanel";

function TreatmentContent({treatments, inspectionItem, inspection}) {
  const [tab, setTab] = useState(1);
  const hasTreatment = Array.isArray(treatments) && treatments.length > 0;
  const inspectionResultNG = inspection?.result === 0;

  const renderPrimaryTreatment = () => (
    <Tabs.Item
      title={`処置0回目`}
      active={tab === 1}
      key={1}
    >
      <TreatmentDetail treatmentNumber={0}
                       inspectionItem={inspectionItem}
                       treatmentUser={inspection.execution_user}
                       treatmentDatetime={inspection.registration_datetime}
                       treatmentLog={
                         hasTreatment
                           ? treatments[0]?.nearest_log?.inspection_result_content
                           : inspection.result_inspection
                       }
                       hasTreatment={hasTreatment}
                       active={tab === 1}
      />
    </Tabs.Item>
  );

  const renderTreatmentTabs = () =>
    treatments.map((treatment) => (
    <Tabs.Item
      title={`処置${treatment.treatment_number}回目`}
      active={tab === treatment.treatment_number + 1}
      key={treatment.treatment_number + 1}
    >
      <TreatmentDetail treatmentNumber={treatment?.treatment_number}
                       inspectionItem={inspectionItem}
                       treatmentUser={treatment?.treatment_user}
                       treatmentDatetime={treatment?.treatment_datetime}
                       treatmentLog={treatment?.log_treatment[0]?.inspection_result_content}
                       hasTreatment={true}
                       commentFiles={treatment?.treatment_comment_files}
                       remarkText={treatment?.remark_text}
                       active={tab === treatment.treatment_number + 1}
      />
    </Tabs.Item>
  ));

  const renderNoTreatmentMessage = () => (
    <span className='flex justify-center items-center w-full text-tenken-gray-700 text-base lg:text-[18px]'>処置履歴なし</span>
  );
  return (
    <ExpandablePanel title="処置結果">
      {hasTreatment ? (
        /* eslint-disable react/style-prop-object */
        <Tabs style="underline"
              theme={tenkenTheme.treatment_tabs}
              onActiveTabChange={(tab) => setTab(tab+1)}
        >
          {renderPrimaryTreatment()}
          {renderTreatmentTabs()}
        </Tabs>
      ) : inspectionResultNG ? (
        <Tabs style="underline"
              theme={tenkenTheme.treatment_tabs}
              onActiveTabChange={(tab) => setTab(tab+1)}
        >
          {renderPrimaryTreatment()}
        </Tabs>
      ) : (
        renderNoTreatmentMessage()
      )}
    </ExpandablePanel>
  );
}

export default TreatmentContent;
